module.exports = __webpack_public_path__ + "static/img/logo1.5f4d4ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo1.png
// module id = TrFT
// module chunks = 1